import { h, Component } from 'preact';

import { joinClasses } from 'utils/utils';

import Tiktok from 'components/bolt/icons/tiktok';
import Youtube from 'components/bolt/icons/youtube';
import Instagram from 'components/bolt/icons/instagram';
import Facebook from 'components/bolt/icons/facebook';
import Twitter from 'components/bolt/icons/twitter';

import s from 'components/editor/hubNavigation/shareIcons/shareIcons.sss';

export default class ShareIcons extends Component {

	constructor(props) {
		super(props);

		this.links = [
			{ id: 'tiktok', url: 'https://www.tiktok.com/@universalpics', icon: <Tiktok height="24" /> },
			{ id: 'youtube', url: 'https://www.youtube.com/UniversalPictures', icon: <Youtube height="24" /> },
			{ id: 'instagram', url: 'https://www.instagram.com/universalpictures/', icon: <Instagram height="24" /> },
			{ id: 'facebook', url: 'https://www.facebook.com/universalpictures/', icon: <Facebook height="24" /> },
			{ id: 'twitter', url: 'https://x.com/UniversalPics', icon: <Twitter height="24" /> }
		];
	}

	render(props) {
		return (
			<div class={joinClasses(s.wrapper, props.class)}>
				{this.links.map(link => <div class={s.item}>{link.icon}</div>)}
			</div>
		);
	}

}